// Copyright © 2021 Move Closer
import { getAbstractButtonProps } from '../../_abstract';
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const bootstrapButtonProps = {
    ...getAbstractButtonProps()
};
